export default "__VITE_ASSET__C$s9_17l__"